module.exports = __webpack_public_path__ + "img/update.d8777fb8.png";